import { React, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import ParticlesJs from "./Components/Particles/Particles";
import Home from "./Components/Home/Home";
import TopBar from "./Components/TopBar/TopBar";
import About from "./Components/About/About";
import Skills from "./Components/Skills/Skills";
import Experience from "./Components/Experience/Experience";
import Portfolio from "./Components/Portfolio/Portfolio";
import Contact from "./Components/Contact/Contact";
import Drawer from "./Components/Drawer/Drawer";
// const Home = React.lazy(() => import("./Components/Home/Home"));
// const About = React.lazy(() => import("./Components/About/About"));
// const TopBar = React.lazy(() => import("./Components/TopBar/TopBar"));
// const Skills = React.lazy(() => import("./Components/Skills/Skills"));
// const Experience = React.lazy(() =>
//   import("./Components/Experience/Experience")
// );
// const Portfolio = React.lazy(() => import("./Components/Portfolio/Portfolio"));
// const Contact = React.lazy(() => import("./Components/Contact/Contact"));

function App() {
  const [drawer, setDrawer] = useState(false);
  const drawerHandler = () => {
    setDrawer(!drawer);
  };
  return (
    <div className="App">
      <ParticlesJs className="particles" />
      <TopBar />
      <div onClick={drawerHandler} className="navBtn d-block d-md-none">
        <span></span>
        <span></span>
        <span></span>
      </div>
      { }
      {drawer && <Drawer drawerHandle={drawerHandler} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
